import "./index.css";
import { jsx } from 'react/jsx-runtime';
import { Image } from '@design-system/image';
var ExtendableImage = function ExtendableImage(_ref) {
  var props = _ref.props,
    element = _ref.element,
    className = _ref.className;
  if (element) return element;
  if (props) return jsx(Image, Object.assign({
    className: className
  }, props));
  return null;
};
export { ExtendableImage };